import React from 'react';

const MyPortfolio = () => {
    return (
        <div className='mt-24'>
            <h1 className='text-2xl text-secondary'>My Portfolio</h1>

            
              <p>Assalamualaikum..My name's Emon Ahmed.<br/>
               I read in class 11. I learn javascript <br/>
                react.js node.js Express.js. mongodb basic..
                I try to improve my self... 
               
         
              </p>
        </div>
    );
};

export default MyPortfolio;